export default __webpack_public_path__ + "static/media/M6 - Angry Tiger.76beeab3.png";